var map = {
	"./en/hos.yml": 153,
	"./en/main.yml": 34,
	"./en/news.yml": 154,
	"./en/sfs.yml": 155,
	"./fr/csu.yml": 156,
	"./fr/faq.yml": 157,
	"./fr/hos.yml": 158,
	"./fr/hos2.yml": 159,
	"./fr/main.yml": 35,
	"./fr/news.yml": 160,
	"./fr/rgpd.yml": 161,
	"./fr/sfs.yml": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;